import type { SceneGroup } from '../../../../../../../../core/models/imageAssets';

export interface SceneListItemUtilProps {
  scene: SceneGroup;
  isSelected: boolean;
  isSide: boolean;
}

export enum FieldImageDownloadOption {
  TIFF = 'tiff',
  TIFF_RGB = 'tiff_rgb',
  TIFF_RAW = 'tiff_raw',
  JPEG = 'jpeg',
  PNG = 'png',
}

export enum AssetDownloadEnum {
  TIFF = 'tiff',
  POLYGON = 'polygon',
  JPEG = 'jpeg',
  POINT = 'point',
  ZONE = 'zone',
  PNG = 'png',
  TIFF_RGB = 'tiff_rgb',
  TIFF_RAW = 'tiff_raw',
}

const FIELD_DOWNLOAD_OPTIONS = Object.values(FieldImageDownloadOption).filter(
  (option) => option !== FieldImageDownloadOption.TIFF_RAW
);

export function getFieldImageDownloadOptions(index: string) {
  return index === 'ndvi' || index === 'savi'
    ? FIELD_DOWNLOAD_OPTIONS
    : [FieldImageDownloadOption.TIFF];
}
